import { CrmFieldOption } from '@utils/models/CrmField';
import { CrmFieldsType } from '@utils/models/CrmFieldsType';
import { Select } from 'antd';

import CustomInput from './components/custom-input/CustomInput';
import DatePickerCustom from './components/date-picker-custom/DatePickerCustom';

const { Option } = Select;

export const CustomFields: {
  [key in CrmFieldsType]?: (props?: {
    hasValue?: boolean;
    value?: any;
    placeholder?: string;
    options?: CrmFieldOption[];
    isOptionName?: boolean;
    onChange?: (value: string) => void;
    suffixIcon?: React.ReactNode;
  }) => JSX.Element;
} = {
  TEXT: props => <CustomInput {...props} />,
  SELECT: props => (
    <Select
      {...((props?.hasValue || props?.value) && { value: props?.value })}
      placeholder={props?.placeholder}
      className="customSelect"
      style={{ width: '100%' }}
      allowClear
      suffixIcon={props?.suffixIcon}
      onChange={e => {
        if (props?.onChange) {
          props?.onChange(e);
        }
      }}
      onClear={() => {
        props?.onChange && props?.onChange('');
      }}
    >
      {props?.options?.map(item => (
        <Option value={props?.isOptionName ? item?.name : String(item?.id)}>{item?.name}</Option>
      ))}
    </Select>
  ),
  DATE: props => (
    <DatePickerCustom
      onChange={e => {
        if (props?.onChange) {
          props?.onChange(e);
        }
      }}
      {...((props?.hasValue || props?.value) && { value: props?.value })}
    />
  )
};
